import { render } from "./TieredMenuSub.vue?vue&type=template&id=5012e93c"
import script from "./TieredMenuSub.vue?vue&type=script&lang=js"
export * from "./TieredMenuSub.vue?vue&type=script&lang=js"
script.render = render

export default script